import { ProductTextArtItemResponse } from '@/types/service-response'

export class ProductTextArt {
  public constructor (
    readonly id: number,
    readonly code: string,
    readonly bezeichnung: string
  ) {}

  static createFromResponse (responseData: ProductTextArtItemResponse[]): Array<ProductTextArt> {
    let result: Array<ProductTextArt> = []
    if (responseData) {
      result = responseData.map((item: ProductTextArtItemResponse ) => {
        return new ProductTextArt(
          item.ID,
          item.Code ? item.Code : '',
          item.Bezeichnung ? item.Bezeichnung : ''
        )
      })
    }
    return result
  }
}
